import {StartFeeData} from './StartFeeData';

export class StartFee {
  num: number;
  startDate;
  finishDate;
  data: StartFeeData[];

  $key: string;
  value: number;
  date: Date;
}
